import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=227f3d2c&scoped=true&"
import script from "./BannerForm.vue?vue&type=script&lang=js&"
export * from "./BannerForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=227f3d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f3d2c",
  null
  
)

export default component.exports